export default __webpack_public_path__ + "static/media/pdf.cf5e021e.svg";